// extracted by mini-css-extract-plugin
export var measureBox = "_av-0";